import { Box, Tooltip } from "@mui/material";

export function Indicator({ color, tooltipLabel }: { color: string; tooltipLabel?: string }) {
  return (
    <Tooltip title={tooltipLabel}>
      <Box
        sx={{
          display: "inline-block",
          width: "10px",
          height: "10px",
          borderRadius: "50%",
          backgroundColor: color,
        }}
      />
    </Tooltip>
  );
}
